export default __webpack_public_path__ + "static/media/wakanda4.2c4ed29e.jpg";